import {
    BarElement,
    CategoryScale,
    Chart,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js"
import React, {useContext, useMemo} from "react"
import {Bar} from "react-chartjs-2"
import {
    fillTopLabels,
} from "./stacked-barchart-widget/chart-utils"
import {Box} from "@mui/material"
import {DataContext} from "../../../src/context/DataContextProvider";

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip)

const options = (bottomLabels) => ({
    plugins: {
        tooltip: {
            bodyAlign: "center", bodyFont: {
                family: 'Urbanist',
                weight: 'bold',
                size: 14,
            },
            callbacks: {
                title: () => "",
                label: (data) => [data.dataset.label + ":", (data.raw).toLocaleString("de-DE", {
                    style: "currency", currency: "EUR", minimumFractionDigits: 2,
                })],
            },
        },
    },
    datasets: {
        bar: {
            barThickness: 48, borderRadius: 4,
            maxBarThickness: 42,
            categoryPercentage: 1,
            barPercentage: 0.5,
        },
    },
    maintainAspectRatio: false,
    aspectRatio: 1,
    responsive: true,
    scales: {
        x: {
            border: {
                display: false,
            },
            position: "top", stacked: true, grid: {
                display: false,
            },
            ticks: {
                display: false,
            },
        },
        y: {
            border: {
                display: false,
            },
            stacked: true,
            grid: {
                display: true,
            },
            ticks: {
                display: true,
            },
        },
        titles: {
            border: {
                display: false,
            },
            stacked: true, position: "bottom", grid: {
                display: false,
            },
            ticks: {
                callback: (_, index) => bottomLabels[index],
                color: "black", font: {
                    family: 'Urbanist',
                    weight: 500,
                    size: 14,
                },
            },
        },
    },
})

const DetailStackedGroupedBarChart = ({widget}) => {
    const {getDataFromPointer} = useContext(DataContext)
    const pointer = useMemo(
        () => widget?.connections?.origin?.pointer,
        [widget],
    )
    const data = getDataFromPointer(pointer)

    const chartData = useMemo(
        () => ({
            labels: data?.bottomLabels ?? fillTopLabels(data),
            datasets: data?.datasets ?? [],
        }),
        [data],
    )

    return (
        <Box minHeight="250px"
             minWidth="600px">
            <Bar
                options={options(data?.bottomLabels ?? [])}
                data={chartData}
            />
        </Box>
    )
}

export default DetailStackedGroupedBarChart
